import { AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG } from '@/common/oem-ai-access.constants';

export function hasOemAiGuideBuilderEntitlement (grantedAIFeatures) {
    return !!grantedAIFeatures?.aiGuideBuilder;
}

export function getSubFlagsFromGrantedAiFeatures (grantedAIFeatures) {
    const features = grantedAIFeatures ?? {};

    return Object.entries(AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG)
        .filter(([grantedKey]) => features[grantedKey])
        .map(([, subFlag]) => subFlag);
}

export function mapGrantedAiEntitlementsToSubFlags (grantedAIFeatures) {
    const features = grantedAIFeatures ?? {};

    return Object.entries(AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG).reduce((subFlags, [entitlementKey, subFlagKey]) => {
        subFlags[subFlagKey] = !!features[entitlementKey];

        return subFlags;
    }, {});
}

export function mapSubFlagsToGrantedAiEntitlements (subFlags) {
    const flags = subFlags ?? {};

    return Object.entries(AEU_GRANTED_AI_FEATURE_TO_SUB_FLAG).reduce((grantedAIFeatures, [entitlementKey, subFlagKey]) => {
        grantedAIFeatures[entitlementKey] = !!flags[subFlagKey];

        return grantedAIFeatures;
    }, {});
}
